// extracted by mini-css-extract-plugin
module.exports = {"navbar":"Layout_navbar__k5-km","pageTitle":"Layout_pageTitle__2XIOE"};